angular.module('satv.track')
    .controller('TrackNoteCtrl', ['$scope', 'TrackNote', function ($scope, TrackNote) {
        "use strict";

        $scope.noteTypes = [
            {id: 1, name: "Note"},
            {id: 2, name: "Event"},
            {id: 3, name: "Requires Attention"}
        ];

        $scope.submit = function (data) {
            $scope.isLoading = true;
            var trackNote = new TrackNote(data);
            trackNote.$save({
                id: trackNote.id
            }, function (response) {
                if ($scope.$close) {
                    $scope.$close(true); // TODO: Emit a MODAL_CLOSE event instead.
                }
            }, function (response) {
                if (response.data.errors) {
                    angular.forEach(response.data.errors, function (e) {
                        growl.error(e.message);
                    });
                }

                $scope.isLoading = false;
                $scope.errors = response.errors;
            });
        };
    }]);


// WEBPACK FOOTER //
// ./vendor/sonyatv/smfcoreclientbundle/Resources/js/angular/controllers/TrackNoteCtrl.js